// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__dc6On","absolute":"Loading_absolute__PyOBr","transparentBg":"Loading_transparentBg__nWcGg"};